import { apiFetch } from "./client.js";
import type { KidBundle } from "./me.js";

export type Txn = KidBundle["recentTxns"][number];

export interface TxnsResponse {
  rows: Txn[];
  continuationToken: string | null;
}

export async function listTxns(
  kidId: string,
  opts: { limit?: number; continuationToken?: string } = {},
): Promise<TxnsResponse> {
  const params = new URLSearchParams();
  if (opts.limit !== undefined) params.set("limit", String(opts.limit));
  if (opts.continuationToken !== undefined) {
    params.set("continuationToken", opts.continuationToken);
  }
  const qs = params.toString();
  const path = `/api/kids/${encodeURIComponent(kidId)}/txns${qs ? `?${qs}` : ""}`;
  return apiFetch<TxnsResponse>(path);
}
